import { atom } from 'recoil'
import { IParameter, IUnit, IUnitPrefix } from './parameters.types'

interface IParametersState {
  units: IUnit[]
  unitPrefixes: IUnitPrefix[]
  items: IParameter[]
}

const parametersAtom = atom<IParametersState>({
  default: { units: [], items: [], unitPrefixes: [] },
  key: 'parameters',
})
export default parametersAtom
